<!--
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Date: 2022-06-26 17:00:47
 * @Description: 页面Html框架（头部导航栏）
-->
<template>
    <div class="no-print" >
        <div uk-sticky>
        <div>
            <nav class="uk-navbar-container" uk-navbar>
                <div class="uk-navbar-left">
                    <a class="uk-navbar-item uk-logo" href="https://www.bearrental.com/">
                        <img class="uk-margin-left" :src="imgLogo" alt="小熊U租" width="108" height="34" />
                    </a>
                    <ul class="uk-navbar-nav uk-visible@l">
                        <li v-for="(item,index) in headerList" :key="index" :class="{ 'uk-active': $route.name.includes(item.name + '-') }">
                            <router-link :to="{name: item.name}">{{$t(item.langKey)}}</router-link>
                            <div v-if="item.children" class="uk-navbar-dropdown" uk-dropdown="offset: -10">
                                <ul class="uk-nav uk-navbar-dropdown-nav">
                                    <li v-for="(c,cIndex) in item.children" :key="cIndex" :class="{ 'uk-active': $route.name === c.pre+c.name }">
                                        <router-link :to="{name: c.pre+c.name}">{{$t(c.langKey)}}</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="uk-navbar-right margin-r-10">
                    <ul class="uk-navbar-nav uk-visible@l">
                        <li v-for="(item,index) in languages" :key="index" :class="{'uk-active':$i18n.locale===item.key}" @click="changLanguage(item.key)"><a href="javascript:void(0);">{{item.label}}</a></li>
                    </ul>
                    <a class="uk-navbar-toggle uk-hidden@l" href="#offcanvas-menu" uk-icon="icon: menu; ratio: 2" uk-toggle></a>
                </div>
            </nav>
        </div>
        <div id="offcanvas-menu" uk-offcanvas="overlay: true; flip: true;">
            <div class="uk-offcanvas-bar">
                <ul class="uk-nav uk-nav-default">
                    <li v-for="(item,index) in headerList" :key="index" :class="{ 'uk-active': $route.name.includes(item.name + '-') }">
                        <router-link :to="{name: item.name}">{{$t(item.langKey)}}</router-link>
                        <div v-if="item.children" class="uk-parent">
                            <ul class="uk-nav-sub">
                                <li v-for="(c,cIndex) in item.children" :key="cIndex" :class="{ 'uk-active': $route.name === c.pre+c.name }">
                                    <router-link :to="{name: c.pre+c.name}">{{$t(c.langKey)}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <hr class="uk-margin-medium" />
                <ul class="uk-nav uk-nav-default">
                    <li ref="changLanguageRef" v-for="(item,index) in languages" :key="index" :class="{'uk-active':$i18n.locale===item.key}" @click="changLanguage(item.key)">
                        <a href="javascript:void(0);">{{item.label}}</a>
                    </li>
                </ul>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import { useStore } from "vuex";
import { defineComponent, getCurrentInstance } from "vue";
import { useRouter } from 'vue-router'
import { headerList } from "../../controller/navOption.js";
import rentGo_commonBiz from "@/tools/rentGo/commons/index.js";

export default defineComponent({
    setup() {
        const store = useStore();
        const { ctx } = getCurrentInstance();
        const router = useRouter();
        const changLanguage = (key) => {
            ctx.$i18n.locale = key;
            store.commit("lang/set", key);
            const currentLangKey = router.currentRoute.value.meta.langKey
            if (currentLangKey) {
                document.title = ctx.$t(currentLangKey);
            }

            // 点击切换，上报数据埋点事件
            rentGo_commonBiz.changLanguage({
                type: key
            });
        };

        return {
            changLanguage,
        };
    },

    data() {
        return {
            imgLogo: `${process.env.VUE_APP_IR_CDN_URL}/common/logo.png`,
            languages: [
                { label: "ENGLISH", key: "en" },
                { label: "简体中文", key: "zh" },
                { label: "繁体中文", key: "zhHant" },
            ],
            headerList,
        };
    },

    methods: {},
});
</script>

<style lang="less" scoped>
.uk-navbar-nav {
    & > li {
        & > a {
            position: relative;
            color: #333333;
            text-transform: none;
            &::before {
                content: "";
                display: block;
                position: absolute;
                left: 15px;
                right: calc(102% - 15px);
                bottom: 24px;
                height: 2px;
                background-color: #00a0e9;
                -webkit-transition: 0.3s ease-in-out;
                transition: 0.3s ease-in-out;
                -webkit-transition-property: right;
                transition-property: right;
            }
        }
        &.uk-active,
        &:hover {
            & > a {
                color: #333333;
                &::before {
                    right: 15px;
                }
            }
        }
    }
}
.uk-navbar-dropdown {
    margin-top: -30px;
}
</style>